var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64645 1.64645C7.84171 1.45118 8.15829 1.45118 8.35355 1.64645L13.3536 6.64645C13.5488 6.84171 13.5488 7.15829 13.3536 7.35355C13.1583 7.54882 12.8417 7.54882 12.6464 7.35355L8.5 3.20711V14C8.5 14.2761 8.27614 14.5 8 14.5C7.72386 14.5 7.5 14.2761 7.5 14V3.20711L3.35355 7.35355C3.15829 7.54882 2.84171 7.54882 2.64645 7.35355C2.45118 7.15829 2.45118 6.84171 2.64645 6.64645L7.64645 1.64645Z",
    fill: "#010F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.2b0a7c5f990d1aa4564b9970ac9316e4.svg";
export { ForwardRef as ReactComponent };